module.exports = __webpack_public_path__ + "assets/manual_constructorHome-21673d20635451c165cb74c0e6af639f.pdf";